// extracted by mini-css-extract-plugin
module.exports = {"center":"NoAvailableWidget_center__SZb3z","text":"NoAvailableWidget_text__7E55T"};